module.exports = __webpack_public_path__ + "static/img/scene7.9a191f26.png";